<template>
    <div :data-question-id="question.id">
        <ul class="checkbox-container">
            <li v-for="option in question.options.items" v-bind:key="option.id" :class="{'selected': option.value, 'disabled': none_of_above_active && (option.id !== none_of_above) }">
                <label>
                    <input type="checkbox" @change="update_done_status" v-model="option.value" :disabled="none_of_above_active && (option.id !== none_of_above)" />{{ option.label }}
                </label>
            </li>
        </ul>
        <form v-if="question.options.flags.includes('custom')" @submit="add_custom" class="checkbox-container-custom">
            <label :for="`other-${question.id}`" v-if="question.options.items.length">Other</label>
            <input type="text" :id="`other-${question.id}`" v-model="custom_option" required="required" placeholder="Please specify" autocomplete="off" />
            <button v-if="custom_option.length > 0">Add</button>
        </form>
    </div>
</template>

<script>
  export default {
    name: 'CheckboxControl',
    props: ['question'],
    data: function(){
      return {
        'custom_n': 0,
        'custom_option': '',
        'none_of_above': this.$props.question.options.hasOwnProperty('none_of_above_id') ? this.$props.question.options.none_of_above_id : null,
        'none_of_above_active': false,
      };
    },
    methods: {
      'get_answer': function () {
        return this.$props.question.options.items.filter((el) => el.value);
      },
      'add_custom': function (e) {
        e.preventDefault();
        this.$data.custom_n = this.$data.custom_n - 1;
        this.$props.question.options.items.push({"label": this.$data.custom_option, "id": this.$data.custom_option, "value": true});
        this.$data.custom_option = '';
        this.update_done_status();
      },
      'update_done_status': function () {
        const answer = this.get_answer();
        this.$props.question.value = answer.map(el => el['id']);
        if (this.$props.question.value.includes(this.$data.none_of_above)){
          this.$props.question.value = [this.$data.none_of_above];
          this.$data.none_of_above_active = true;
        } else {
          this.$data.none_of_above_active = false;
        }
        this.$emit('answered', {
          'status': answer.length > 0,
          'id': this.$props.question.id,
          'value': this.$props.question.value,
        });
      }
    }
  }
</script>

<style scoped>
    .checkbox-container li.disabled > label {
        background: #8a8a8a;
        color: #dddddd;
    }
    .checkbox-container {
        background: #ffffff;
    }
    .checkbox-container-custom {
        display: flex;
        width: 100%;
        margin-top: 0.5rem;
    }
    .checkbox-container-custom label {
        padding: 0.7rem;
        background: #dddddd;
    }
    .checkbox-container-custom input {
        width: 100%;
        border: none;
        background: #ffffff;
        outline: none;
        padding: 0.7rem;
        height: 2.6rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        border: 1px solid #dddddd;
        border-left: none;
    }
    @media only screen and (min-width: 480px) {
        div[data-question-id="Q1"] ul.checkbox-container {
            border-left: none;
        }
        div[data-question-id="Q1"] ul.checkbox-container:after {
            content: '';
            display: block;
            clear: both;
        }
        div[data-question-id="Q1"] ul.checkbox-container li {
            float: left;
            width: 50%;
            box-shadow: 1px 1px 0 rgba(0,0,0,0.13) inset,  1px 1px 0 #dddddd;
        }
    }
    @media only screen and (min-width: 720px) {
        div[data-question-id="Q1"] ul.checkbox-container li {
            width: 33.333333333%;
        }
    }
    @media only screen and (min-width: 1024px) {
        div[data-question-id="Q1"] ul.checkbox-container li {
            width: 25%;
        }
    }
</style>
